export const AWS_API = 'https://j16am9chll.execute-api.ap-southeast-2.amazonaws.com';
export const region = 'ap-southeast-2';
export const userPoolId = 'ap-southeast-2_6kOwm7nAZ';
export const userPoolClientId = '7fcbuf3tnq69ek4bet1lv885m7';